var React = require('react');

function Checked (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20.5","cy":"20.5","r":"20.5","fill":"#7EBA2A","fillOpacity":"0.3","key":0}),React.createElement("line",{"x1":"10.8942","y1":"20.8089","x2":"17.013","y2":"28.6667","stroke":"#7EBA2A","strokeWidth":"3","key":1}),React.createElement("line",{"x1":"31.6625","y1":"13.9495","x2":"16.9533","y2":"30.582","stroke":"#7EBA2A","strokeWidth":"3","key":2})]);
}

Checked.defaultProps = {"width":"21","height":"21","viewBox":"0 0 41 41","fill":"none"};

module.exports = Checked;

Checked.default = Checked;
